<template>
  <div class="ocr-report-document" :class="{ 'ocr-report-document--collapsed': collapsed }">
    <div class="ocr-report-document-head">
      <span class="ocr-report-document-title">Document preview</span>
      <div class="ocr-report-document-actions">
        <v-btn size="x-small" variant="text" @click="toggleCollapsed">
          {{ collapsed ? "Show" : "Minimize" }}
        </v-btn>
        <v-btn v-if="objectUrl && !collapsed" size="x-small" variant="text" @click="reload">Reload</v-btn>
      </div>
    </div>
    <template v-if="!collapsed">
    <div v-if="loading" class="ocr-report-document-placeholder">Loading document…</div>
    <p v-else-if="error" class="ocr-report-document-error">{{ error }}</p>
    <iframe
      v-else-if="objectUrl && isPdf"
      class="ocr-report-document-frame"
      :src="objectUrl"
      title="Report PDF preview"
    />
    <p v-else-if="objectUrl" class="ocr-report-document-placeholder">
      Preview available for PDF only. File loaded as download in browser if opened directly.
    </p>
    <p v-else class="ocr-report-document-placeholder">Select a report to preview.</p>
    </template>
  </div>
</template>

<script>
import ocrApi, { formatOcrApiError } from "@/services/ocrApi";

export default {
  name: "OcrReportDocument",
  props: {
    filename: { type: String, default: null },
  },
  emits: ["update:collapsed"],
  data() {
    return {
      loading: false,
      error: "",
      objectUrl: "",
      isPdf: false,
      collapsed: false,
    };
  },
  watch: {
    filename: {
      immediate: true,
      handler() {
        this.reload();
      },
    },
  },
  beforeUnmount() {
    this.revokeUrl();
  },
  methods: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
      this.$emit("update:collapsed", this.collapsed);
    },
    revokeUrl() {
      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = "";
      }
    },
    async reload() {
      this.revokeUrl();
      this.error = "";
      if (!this.filename) return;

      this.loading = true;
      try {
        const { data, headers } = await ocrApi.get(
          `api/v1/reports/${encodeURIComponent(this.filename)}/document`,
          { responseType: "blob" },
        );
        const type = headers["content-type"] || data.type || "";
        this.isPdf = type.includes("pdf") || this.filename.toLowerCase().endsWith(".pdf");
        this.objectUrl = URL.createObjectURL(
          data instanceof Blob ? data : new Blob([data], { type: type || "application/pdf" }),
        );
      } catch (e) {
        this.error = formatOcrApiError(e, "Could not load document for preview.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
